import { useEffect, useState } from 'react'
import { getNotesByStatusAsync } from '../redux/flows/portal/notes'
import { useAppDispatch, useAppSelector } from '../redux/store'

export function useNotesPoll() {
  const clinicId = useAppSelector((state) => state.studioAuth.studioDetails?.id)

  const [intervalId, setIntervalId] = useState<any>(null)
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!intervalId && clinicId) {
      const intervalIdLocal = setInterval(() => {
        dispatch(getNotesByStatusAsync({ clinicId: clinicId }))
      }, 3000)

      setIntervalId(intervalIdLocal)
    }

    return () => {
      clearInterval(intervalId)
    }
  }, [intervalId, clinicId])
}
